<div class="container py-4" style="min-height: calc(100vh - 178px)">
    <div class="row align-items-center card-details-wrapper d-flex justify-content-center">
        <div class="spinner-border text-primary" role="status" *ngIf="!cardDetail || !subProductRatesLookup else cardInfoTemplate">
            <span class="sr-only">Loading...</span>
        </div>
        <ng-template #cardInfoTemplate>
            <div class="col-md-6 col-sm-12 mb-3 text-center text-sm-left">
                <img [src]="cardDetail.imageUrl" [alt]="cardDetail?.name"/>
            </div>
            <div class="col-md-6 col-sm-12">
                <h1 class="text-primary" [innerHTML]="cardDetail.title"></h1>
                <h4 class="text-primary,black-heading" [innerHTML]="cardDetail.subTitle"></h4>
               <div [innerHTML]="cardDetail.shortInfo | replaceString: replaceContext"></div>
                <div class="d-flex flex-column align-items-center">
                    <button class="apply-btn btn" (click)="gotoCXUrl()" *ngIf="loanPurpose === 'BCC' || loanPurpose === 'BCC_CHARGE'">Apply
                        Now
                    </button>
                    <button class="apply-btn btn" (click)="gotoCXUrl()"
                            *ngIf="loanPurpose === 'CC'">{{appConfig?.homepage?.homeButton1Text ?? 'See if I Pre-Qualify?'}}
                    </button>
                    <button type="button" *ngIf="cardDetail.applyByMail" class="mt-2 btn btn-link text-decoration-none" (click)="applyByEmail()" [disabled]="processingLink">
                        <span class="text-decoration-underline">Apply by mail</span>
                        <span class="spinner-border spinner-border-sm ms-1w" role="status" *ngIf="processingLink"></span>
                    </button>
                </div>
            </div>


            <div class="row mt-5" *ngIf="cardDetail.longInfo">
                <h2 class="text-primary">Additional Benefits</h2>
                <div [innerHTML]="cardDetail.longInfo | replaceString: subProductRatesLookup"></div>
            </div>

            <div class="row mt-4" *ngIf="cardDetail?.disclosures && cardDetail.disclosures.length">
                <h2 class="text-primary">Disclosures</h2>
                <div [innerHTML]="(cardDetail.disclosures | replaceString: {disclosureUrl}) || ''"></div>
            </div>
        </ng-template>
    </div>
</div>
